import COLOR from 'constants/color';
import { IconProps } from 'interfaces';
import { isDarkMode } from 'utils/validators';

const AccountabilityBuddy = ({
  className = '~w-4/5 ~h-4/5',
  fill = COLOR.GRAY['900'],
  fillDarkMode = COLOR.WHITE
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'>
      <circle cx='8' cy='7.5' r='2.75' fill={fillColor} opacity='0.55' />
      <path
        d='M3.25 18.25c0-2.347 2.126-4.25 4.75-4.25s4.75 1.903 4.75 4.25'
        stroke={fillColor}
        strokeWidth='1.75'
        strokeLinecap='round'
        opacity='0.55'
      />
      <circle cx='15.5' cy='8' r='3' fill={fillColor} />
      <path
        d='M9.75 18.5c0-2.623 2.574-4.75 5.75-4.75s5.75 2.127 5.75 4.75'
        stroke={fillColor}
        strokeWidth='1.75'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default AccountabilityBuddy;
